import { defineComponent as _defineComponent } from 'vue'
export interface Props {
  status: string;
  statusConfigs?: StatusConfig;
  fullwidth?: boolean;
}


import { computed } from 'vue';

const TEXT_COLOR_GRAY = '#363b47';
const BG_COLOR_GRAY = '#9fa5b3';

const TEXT_COLOR_GREEN = '#004546';
const BG_COLOR_GREEN = '#37da88';

const TEXT_COLOR_YELLOW = '#5f4000';
const BG_COLOR_YELLOW = '#ffd800';

const TEXT_COLOR_RED = '#5d0029';
const BG_COLOR_RED = '#ff4f80';

interface StatusDisplayConfig {
  text: string;
  color: string;
  backgroundColor: string;
}

export interface StatusConfig {
  [key: string]: StatusDisplayConfig;
}

// Default status configs that can be overridden via props
export const DEFAULT_STATUS_CONFIGS: StatusConfig = {
  QUEUED: {
    text: 'Queued',
    color: TEXT_COLOR_GRAY,
    backgroundColor: BG_COLOR_GRAY,
  },
  PROCESSING: {
    text: 'Processing',
    color: TEXT_COLOR_YELLOW,
    backgroundColor: BG_COLOR_YELLOW,
  },
  COMPLETED: {
    text: 'Completed',
    color: TEXT_COLOR_GREEN,
    backgroundColor: BG_COLOR_GREEN,
  },
  ERROR: {
    text: 'Error',
    color: TEXT_COLOR_RED,
    backgroundColor: BG_COLOR_RED,
  },
};

export default /*#__PURE__*/_defineComponent({
  __name: 'LabelStatus',
  props: {
    status: null,
    statusConfigs: { default: () => DEFAULT_STATUS_CONFIGS },
    fullwidth: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { status: string, statusConfigs: StatusConfig, fullwidth: boolean };



const displayConfig = computed(() => {
  return props.statusConfigs[props.status];
});

const classList = computed(() => {
  const classList: string[] = ['label-status'];
  if (props.fullwidth) classList.push('fullwidth');
  return classList;
});

const style = computed(() => ({
  color: displayConfig.value.color,
  backgroundColor: displayConfig.value.backgroundColor,
}));

return { __sfc: true,TEXT_COLOR_GRAY, BG_COLOR_GRAY, TEXT_COLOR_GREEN, BG_COLOR_GREEN, TEXT_COLOR_YELLOW, BG_COLOR_YELLOW, TEXT_COLOR_RED, BG_COLOR_RED, DEFAULT_STATUS_CONFIGS, props, displayConfig, classList, style }
}

})